import React, { useState, useEffect } from 'react';
import EmojiCard from './components/EmojiCard';
import './App.css';

function App() {
  const [emojis, setEmojis] = useState([]);         // All emojis from API
  const [searchTerm, setSearchTerm] = useState(''); // User’s search input
  const [copiedId, setCopiedId] = useState(null);   // ID of copied emoji

  // Fetch emoji data when the component mounts
  useEffect(() => {
    // Using EmojiHub API to get all emojis
    fetch('https://emojihub.yurace.pro/api/all')
      .then(response => response.json())
      .then(data => {
        setEmojis(data); // Save emoji data in state
      })
      .catch(err => console.error(err));
  }, []);

  // Handle input change
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  // Handle copying an emoji
  const handleCopy = (id, char) => {
    navigator.clipboard.writeText(char)  // copy emoji to clipboard
      .then(() => {
        setCopiedId(id);                // mark this emoji as copied
        // Remove the "Copied!" message after 1 second
        setTimeout(() => setCopiedId(null), 1000);
      });
  };

  // Filter emojis based on searchTerm
  const filtered = emojis.filter(emoji =>
    emoji.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="App">
      <h1>Emoji Search App</h1>
      <input
        type="text"
        placeholder="Search emojis..."
        value={searchTerm}
        onChange={handleSearchChange}
      />
      <div className="emoji-container">
        {filtered.map((emoji, index) => (
          <EmojiCard 
            key={index}
            emoji={emoji}
            copied={copiedId === emoji.name}
            onCopy={() => handleCopy(emoji.name, String.fromCodePoint(parseInt(emoji.unicode[0].slice(2), 16)))}
          />
        ))}
      </div>
    </div>
  );
}

export default App;
